import React, { useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { Components } from './styled';
import { ReactComponent as CogsIcon } from '../../../assets/sidebarIcons/icon-cogs.svg';
import { ReactComponent as CogsIconActive } from '../../../assets/sidebarIcons/icon-cogs-active.svg';
import {
  CONTENT_MANAGEMENT_PATH,
  defaultSection,
  getSectionPath,
  sectionGroups,
} from '../../../screens/ContentManagement/sections';

const LABEL = 'Content Management';
const SUB_MENU_ID = 'content-management-sub-menu';

const ContentManagementNav = ({ isCollapsed = false }: { isCollapsed?: boolean }) => {
  const navigate = useNavigate();

  const isInside = !!useMatch({ path: `${CONTENT_MANAGEMENT_PATH}/*` });
  const sectionMatch = useMatch({ path: `${CONTENT_MANAGEMENT_PATH}/:section/*` });
  const activeKey = sectionMatch?.params.section;

  const [isExpanded, setIsExpanded] = useState(isInside);

  useEffect(() => {
    if (isInside) {
      setIsExpanded(true);
    }
  }, [isInside]);

  const onParentClick = () => {
    if (isCollapsed) {
      // Sub-menu is hidden while collapsed: just go to the current (or first) section.
      if (!isInside) {
        navigate(getSectionPath(defaultSection.key));
      }
      return;
    }
    if (!isInside) {
      setIsExpanded(true);
      navigate(getSectionPath(defaultSection.key));
      return;
    }
    setIsExpanded((prev) => !prev);
  };

  const showSubMenu = isExpanded && !isCollapsed;

  return (
    <Components.Wrapper>
      <Components.ParentButton
        type={'button'}
        $isCollapsed={isCollapsed}
        title={isCollapsed ? LABEL : undefined}
        aria-label={isCollapsed ? LABEL : undefined}
        aria-expanded={isCollapsed ? undefined : showSubMenu}
        aria-controls={isCollapsed ? undefined : SUB_MENU_ID}
        onClick={onParentClick}>
        <Components.IconWrapper $isActive={isInside} $isCollapsed={isCollapsed}>
          {isInside ? <CogsIconActive /> : <CogsIcon />}
        </Components.IconWrapper>
        {!isCollapsed && (
          <>
            <Components.Label $isActive={isInside}>{LABEL}</Components.Label>
            <Components.Chevron $isExpanded={showSubMenu} aria-hidden={'true'} />
          </>
        )}
      </Components.ParentButton>
      {showSubMenu && (
        <Components.SubMenu id={SUB_MENU_ID}>
          {sectionGroups.map((group) => (
            <React.Fragment key={group.title}>
              <Components.GroupTitle>{group.title}</Components.GroupTitle>
              {group.sections.map((section) => {
                const isActive = section.key === activeKey;
                return (
                  <Components.SubItem
                    key={section.key}
                    to={getSectionPath(section.key)}
                    $isActive={isActive}
                    aria-current={isActive ? 'page' : undefined}>
                    {section.title}
                  </Components.SubItem>
                );
              })}
            </React.Fragment>
          ))}
        </Components.SubMenu>
      )}
    </Components.Wrapper>
  );
};

export default ContentManagementNav;
